// JobCard.tsx
import React, { useState } from "react";
import { Button } from "../../../common/components";
import { Head3, Head4, Paragraph } from "../../../common/constants/core.style";
import { IconSvg } from "../../../common/constants/images";
import {
  JobCardContainer,
  JobDetails,
  LocationContainer,
  ApplyContainer,
  JobDetailDescription,
} from "./style";
import { Link as RouterLink } from "react-router-dom";

const JobDetailCard: React.FC<{ }> = () => {

  return (
    <JobCardContainer>
      
      <Head4>Registered Nurse</Head4>
      <LocationContainer><IconSvg.location className="icon" />Melbourne VIC, Australia</LocationContainer>
      <ApplyContainer>
        <Button url={""}>Apply Now</Button>
        <RouterLink className="save-btn" to={""}><IconSvg.SaveIcon /></RouterLink>
      </ApplyContainer>
      <JobDetails>
        <Head4 className="job-head">Job details</Head4>
        <Paragraph className="desc">Here’s how the job details align with your job preferences. Manage job preferences anytime in your profile.</Paragraph>
        <Paragraph className="title">Job Location :</Paragraph>
        <Paragraph>Auckland</Paragraph>
        <Paragraph className="title">Experience :</Paragraph>
        <Paragraph>0-1 Years</Paragraph>
        <Paragraph className="title">Salary Range :</Paragraph>
        <Paragraph>Not disclosed</Paragraph>
        <Paragraph className="title">Shift and schedule :</Paragraph>
        <Paragraph>Fixed shift</Paragraph>
      </JobDetails>
      <JobDetailDescription>
        <Head4 className="heading">Where does it come from</Head4>
        <Paragraph>It is a long established fact that a reader will be distracted by the readable content of a page when looking at its layout. The point of using Lorem Ipsum is that it has a more-or-less normal distribution of letters, as opposed to using 'Content here, content here', making it look like readable English. Many desktop publishing packages and web page editors now use Lorem Ipsum as their default model text, and a search for 'lorem ipsum' will uncover many web sites still in their infancy. Various versions have evolved over the years, sometimes by accident, sometimes on purpose (injected humour and the like).</Paragraph>
        <Paragraph>
        There are many variations of passages of Lorem Ipsum available, but the majority have suffered alteration in some form, by injected humour, or randomised words which don't look even slightly believable. If you are going to use a passage of Lorem Ipsum, you need to be sure there isn't anything embarrassing hidden in the middle of text. All the Lorem Ipsum generators on the Internet tend to repeat predefined chunks as necessary, making this the first true generator on the Internet. It uses a dictionary of over 200 Latin words, combined with a handful of model sentence structures, to generate Lorem Ipsum which looks reasonable. The generated Lorem Ipsum is therefore always free from repetition, injected humour, or non-characteristic words etc.
        Lorem Ipsum is simply dummy text of the printing and typesetting industry. Lorem Ipsum has been the industry's standard dummy text ever since the 1500s, when an unknown printer took a galley of type and scrambled it to make a type specimen book. It has survived not only five centuries, but also the leap into electronic typesetting, remaining essentially unchanged. It was popularised in the 1960s with the release of Letraset sheets containing Lorem Ipsum passages, and more recently with desktop publishing software like Aldus PageMaker including versions of Lorem Ipsum.
        </Paragraph>
      </JobDetailDescription>

    </JobCardContainer>
  );
};

export default JobDetailCard;
